/*
 * Anchors
 */

export enum AnchorVertical {
  TOP = "top",
  MIDDLE = "middle",
  BOTTOM = "bottom",
}

export enum AnchorHorizontal {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}

export type Anchor = [AnchorVertical, AnchorHorizontal];

export class UnsupportedAnchorError extends Error {
  constructor(value: string) {
    super(`Unsupported Anchor "${value}"`);
  }
}

/*
 * Sizes
 */

export enum Unit {
  MM = "mm",
  PX = "px",
  P10K = "p10k",
}

export interface Length<U extends Unit> {
  unit: U;
  value: number;
}

export interface Size<U extends Unit> {
  height: Length<U>;
  width: Length<U>;
}

export interface Position<U extends Unit> {
  x: Length<U>;
  y: Length<U>;
}

/*
 * Box Model
 */

export interface Boxable {
  // Size
  width: Length<Unit.P10K>;
  height: Length<Unit.P10K>;

  // Position
  anchorSelf: Anchor;
  anchorPage: Anchor;
  x: Length<Unit.P10K>;
  y: Length<Unit.P10K>;

  // Stacking
  zIndex: number;
}
